import { calculateSpreadAndMargin } from "./calculate-spread-margin";
import { clearCreateTransaction } from "./clear-create-transaction";
import { clearSalesPersonDetails } from "./clear-salesperson-details";
import { exportTransactions } from "./export-transactions";
import { fetchDomainDetails } from "./fetch-domain-details";
import { fetchSalesPersonNames } from "./fetch-salesPerson-names";
import { fetchSearchTransactions } from "./fetch-search-transactions.js";
import { fetchStoredDealerAccountDetails } from "./fetch-stored-dealer-account-details";
import { fetchStoredParentDealerAccountDetails } from "./fetch-stored-parent-dealer-account-details";
import {
  fetchRelatedAccounts,
  setParentDealerAccountDetailsAtTxn,
} from "./get-dealer-account-details";
import getUserDetailsFromOkta from "./get-user-details-from-okta";
import { getUserDetails } from "./get-user-details.js";
import { loadBusinessActivities } from "./load-business-activities";
import { loadMachinesFromCache } from "./load-machine-from-cache";
import { loadSimulatedBusinessActivities } from "./load-simulated-business-activities";
import { loadSimulation } from "./load-simulation.js";
import { loadTranslatedTexts } from "./load-translated-texts";
import { resetCreateTransactionDetailsandResObj } from "./reset-create-transaction-details-and-res-obj.js";
import { resetPaymentTypeObject } from "./reset-payment-type-object";
import { resetSearchObj } from "./reset-search-obj";
import { resetSearchTxnAccountDropdowns } from "./reset-search-txn-account-dropdowns.js";
import { setActionType } from "./set-actionType-value";
import { setBidsPaymentTypeTextValue } from "./set-bids-paymentType-text-value";
import { setBidsTextValue } from "./set-bids-text-value";
import { setCreateTransactionResponseObj } from "./set-create-transaction-response-obj";
import { setDiscountProgram } from "./set-discount-program";
import { setDropdownValue } from "./set-dropdown-value";
import { setIsSimulateMode } from "./set-is-simulate-mode.js";
import { setMachine } from "./set-machine";
import { setOnSubmitDetails } from "./set-on-submit-details";
import { setPaymentMethod } from "./set-payment-method.js";
import { setSalesPersonId } from "./set-salesperson-id";
import { setSearchObj } from "./set-search-obj";
import {
  resetSearchPageComponents,
  setSelectedTransactions,
  setSelectedTxnStatus,
  setTableVisibility,
} from "./set-search-page-components";
import { setSelectedAccordion } from "./set-selected-accordion.js";
import { setTextValue } from "./set-text-value";
import { setTransactionBidDropdownValue } from "./set-transaction-bid-dropdown-value";
import { setTransactionPaymentDropdownValue } from "./set-transaction-payment-dropdown-value.js";
import { setTransactionRequestDropdownValue } from "./set-transaction-request-dropdown-value";
import { setUserPreferenceLocale } from "./set-user-preference-locale";
import { setViewTransaction } from "./set-view-transaction";
import { setViewTransactionBids } from "./set-view-transaction-bids";
import {clearAllAttachments} from "./clear-attachments.js";
import {setTransactionAttachmentResponse} from "./transaction-attachment-response.js";
import {uploadAttachments} from "./upload-attachments.js";
import {removeAttachment} from "./remove-attachment.js";
import {clearAttachmentResponse} from "./clear-attachment-response.js";
import {setTransactionStatus} from "./setTransactionStatus.js";
import {setSalesPersonName} from "./set-salesperson-name";

const actionCreators = {
  fetchDomainDetails,
  setDropdownValue,
  setDiscountProgram,
  setTextValue,
  setTransactionBidDropdownValue,
  setTransactionPaymentDropdownValue,
  setTransactionRequestDropdownValue,
  loadBusinessActivities,
  getUserDetailsFromOkta,
  getUserDetails,
  setSalesPersonId,
  clearSalesPersonDetails,
  setBidsTextValue,
  fetchRelatedAccounts,
  setParentDealerAccountDetailsAtTxn,
  loadMachinesFromCache,
  setBidsPaymentTypeTextValue,
  setPaymentMethod,
  setMachine,
  calculateSpreadAndMargin,
  resetPaymentTypeObject,
  setSelectedAccordion,
  resetCreateTransactionDetailsandResObj,
  setOnSubmitDetails,
  setCreateTransactionResponseObj,
  clearCreateTransaction,
  setIsSimulateMode,
  loadSimulation,
  fetchSearchTransactions,
  fetchStoredDealerAccountDetails,
  fetchSalesPersonNames,
  fetchStoredParentDealerAccountDetails,
  resetSearchTxnAccountDropdowns,
  setActionType,
  setViewTransaction,
  setSalesPersonName,
  setViewTransactionBids,
  exportTransactions,
  setSearchObj,
  resetSearchObj,
  loadTranslatedTexts,
  setSelectedTransactions,
  setTableVisibility,
  setSelectedTxnStatus,
  resetSearchPageComponents,
  setUserPreferenceLocale,
  loadSimulatedBusinessActivities,
  clearAllAttachments,
  setTransactionAttachmentResponse,
  uploadAttachments,
  removeAttachment,
  clearAttachmentResponse,
  setTransactionStatus
};

export default actionCreators;